import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import Cookies from 'js-cookie';
import { Auth_APIs } from '../APIs/Auth_APIs';
import { Global_Toast } from './GlobalToast';

const Initial_User = {
    User: {
        token: Cookies.get('aaryapar-exchange-jwt-token_') || localStorage.getItem('aaryapar-exchange-jwt-token_') || '',
        data: {
            _id: '',
            name: '',
            displayname: '',
            balance: 0,
            exposure: 0,
            currencyCode: ""
        }
    },
    Set_User: () => { },
};

export const User_Context = createContext(Initial_User);

const parseUserInfoResponse = (response) => {
    const payload = response?.data?.data ?? response?.data ?? {};
    const { token, ...userData } = payload;

    return {
        balance: userData.balance ?? 0,
        exposure: userData.exposure ?? 0,
        ...userData,
    };
};

const User = ({ children }) => {
    const [User, Set_User] = useState(Initial_User.User);
    const { Notify_Toast } = useContext(Global_Toast);
    const userInfoRequestIdRef = useRef(0);
    const betRefreshTimeoutsRef = useRef([]);

    const getUserInfo = () => {
        try {
            const ValidationToken = Cookies.get('aaryapar-exchange-jwt-token_') || localStorage.getItem('aaryapar-exchange-jwt-token_');

            if (!ValidationToken) {
                return Promise.resolve();
            }

            const requestId = ++userInfoRequestIdRef.current;

            return Auth_APIs.Get_User_Info(ValidationToken)
                .then((response) => {
                    if (requestId !== userInfoRequestIdRef.current) {
                        return;
                    }

                    const userData = parseUserInfoResponse(response);

                    Set_User({
                        token: ValidationToken,
                        data: {
                            ...userData,
                            balance: userData.balance ?? 0,
                            exposure: userData.exposure ?? 0,
                        }
                    });
                })
                .catch((error) => {
                    if (requestId !== userInfoRequestIdRef.current) {
                        return;
                    }

                    if (error?.response?.data?.errors) {
                        Notify_Toast("error", error.response.data.errors);
                    } else if (error?.response?.data?.msg) {
                        Notify_Toast("error", error.response.data.msg);
                    }
                });
        } catch (error) {
            console.log(error);
            return Promise.resolve();
        }
    };

    const applyWalletUpdate = (walletData = {}) => {
        if (walletData.balance == null && walletData.exposure == null) {
            return;
        }

        Set_User((prev) => ({
            ...prev,
            data: {
                ...prev.data,
                ...(walletData.balance != null ? { balance: walletData.balance } : {}),
                ...(walletData.exposure != null ? { exposure: walletData.exposure } : {}),
            },
        }));
    };

    const refreshUserInfoAfterBet = () => {
        betRefreshTimeoutsRef.current.forEach(clearTimeout);
        betRefreshTimeoutsRef.current = [];

        getUserInfo();

        [1000, 2500].forEach((delay) => {
            const timeoutId = setTimeout(() => {
                getUserInfo();
            }, delay);
            betRefreshTimeoutsRef.current.push(timeoutId);
        });
    };

    useEffect(() => {
        if (User.token) {
            getUserInfo();
            const intervalId = setInterval(() => {
                getUserInfo();
            }, 10000);

            return () => {
                clearInterval(intervalId);
                betRefreshTimeoutsRef.current.forEach(clearTimeout);
            };
        }
    }, [User.token]);

    return (
        <User_Context.Provider value={{ User, Set_User, getUserInfo, applyWalletUpdate, refreshUserInfoAfterBet }}>
            {children}
        </User_Context.Provider>
    );
};

export default User;
